import {observer} from "mobx-react";
import {useEffect} from "react";
import {DATETIME_VIEW} from "../../../../../components/datetime-v2/datetime-v2";
import {getFormattedDate} from "../../../../../utilities/date-utilities";
import {FormFieldLine} from "../../../../../components/form-field-line/form-field-line";
import {SelectDropdown} from "../../../../../components/inputs/select-dropdown/select-dropdown";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import {DATE_FORMAT, TIME_FORMAT, TIME_FORMAT_TRANSLATIONS_MAP} from "../../../../../services/timezone-service";
import TimezoneStore from "../../../../../stores/timezone-store";

interface ITimezoneSettingsProps {
    timezoneStore: TimezoneStore
}
const TimezoneSettings : React.FC<ITimezoneSettingsProps> = observer(({timezoneStore})=> {
    const { getTranslation } = useDashboardTranslation();
    const pageScope = 'dashboard-settings-store';
    const dateOptions = Object.values(DATE_FORMAT).map((value) => ({
        label: getFormattedDate({
            utcDateString: new Date().toISOString(),
            dateFormat: value,
            dateTimeView:DATETIME_VIEW.DATE_ONLY,
            timeFormat: timezoneStore.timeFormat,
            timeZone: timezoneStore.timezone
        }),
        value
    }));
    const timeOptions = Object.values(TIME_FORMAT).map((value) => ({
        label: getTranslation(TIME_FORMAT_TRANSLATIONS_MAP[value], pageScope),
        value
    }));
    useEffect(() => {
        timezoneStore.loadTimezoneList();
    }, [timezoneStore]);
    
    return (
        <>
            <FormFieldLine 
                label={getTranslation('STORE_TIMEZONE', pageScope)} 
                note={getTranslation('STORE_TIMEZONE_NOTE', pageScope)}
                dataName="store_timezone"
            >
                <SelectDropdown
                    options={timezoneStore.timezoneOptions}
                    value={timezoneStore.timezoneOptions.find(option => option.value === timezoneStore.timezone)}
                    isLoading={timezoneStore.isLoadingTimezoneList}
                    onChange={(option) => option && timezoneStore.setTimezone(option.value as string)}
                />
            </FormFieldLine>
            <FormFieldLine 
                label={getTranslation('STORE_DATE_FORMAT', pageScope)} 
                note={getTranslation('STORE_DATE_FORMAT_NOTE', pageScope)}
                dataName="store-date-format"
            >
                <SelectDropdown options={dateOptions} value={dateOptions.find(i => i.value === timezoneStore?.dateFormat)} onChange={(v=>timezoneStore?.setDateFormat(v?.value as DATE_FORMAT))}/>
            </FormFieldLine>
            <FormFieldLine 
                label={getTranslation('STORE_TIME_FORMAT', pageScope)} 
                note={getTranslation('STORE_TIME_FORMAT_NOTE', pageScope)}
                dataName="store-time"
            >
                <SelectDropdown options={timeOptions} value={timeOptions.find(i => i.value === timezoneStore?.timeFormat)} onChange={(v=>timezoneStore?.setTimeFormat(v?.value as TIME_FORMAT))}/>
            </FormFieldLine>
        </>
    )
});

export default TimezoneSettings;